/**
 * @description Pack rail header logo choice (LYN-361)
 *
 * Key features:
 * - Open = logoUrl only; collapsed = logoMarkUrl || symbolUrl; else org initial
 *
 * @dependencies none
 *
 * @notes Person-card copy lives in PackSOSidebar using the same firstName /
 *   lastName / email fields as LynxPay UserProfile. Do not add a second user SoT.
 */

/**
 * Open rail = logoUrl only. Collapsed = logoMarkUrl || symbolUrl. Else org initial.
 *
 * @param {{ isOpen: boolean, logoUrl?: string|null, logoMarkUrl?: string|null, symbolUrl?: string|null, platformName?: string }} args
 * @returns {{ kind: 'logo'|'mark'|'initial', src: string|null, initial: string }}
 */
export function packRailLogo({ isOpen, logoUrl, logoMarkUrl, symbolUrl, platformName }) {
  const initial = String(platformName || 'O').trim().charAt(0).toUpperCase() || 'O';
  if (isOpen) {
    return logoUrl
      ? { kind: 'logo', src: logoUrl, initial }
      : { kind: 'initial', src: null, initial };
  }
  const mark = logoMarkUrl || symbolUrl || null;
  return mark
    ? { kind: 'mark', src: mark, initial }
    : { kind: 'initial', src: null, initial };
}
